<div class="password-reset-modal">
  @if (showResponse && passwordResetMessage) {
    <header class="modal__header">
      <h2 id="modalLabel">{{ passwordResetMessage.title }}</h2>
      <button
        type="button"
        class="button modal__button--close"
        (click)="closeModal(true)"
        [attr.aria-label]="'general.label.close' | translate"
      >
        <i class="icon icon-ui-close--sm"></i>
      </button>
    </header>
    <div class="modal__content">
      <div [internalInnerHtml]="passwordResetMessage.body" [userEventSource]="userEventSource"></div>
      @if (showEmailReset && passwordResetNoEmailAccess) {
        <div class="toast__item">
          <div class="toast__content">
            <h4 class="toast__title">{{ passwordResetNoEmailAccess.title }}</h4>
            <div class="toast__message" [internalInnerHtml]="passwordResetNoEmailAccess.body" [userEventSource]="userEventSource"></div>
          </div>
          <div class="toast__cta">
            <div class="button__group">
              <button type="button" class="button button--primary" (click)="triggerEmailResetModal($event)">
                <span>{{ 'general.label.continue' | translate }}</span>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="modal__footer">
      <button type="button" class="button button--secondary" (click)="openResetForm($event)">
        <i class="icon icon icon-ui-arrow--left"></i>
        <span>{{ (isSuccess ? 'general.label.try_again' : 'general.label.back') | translate }}</span>
      </button>
      @if (!inputs?.alternateMode) {
        <button type="button" class="button button--primary" (click)="closeModal(true, $event)">
          <span>{{ 'general.label.close' | translate }}</span>
        </button>
      }
      @if (inputs?.alternateMode) {
        <button type="button" class="button button--primary" (click)="back($event)">
          <span>{{ 'user.label.back_to_login' | translate }}</span>
        </button>
      }
    </div>
  } @else {
    <header class="modal__header">
      <h2 [ngStyle]="color && { color: 'black' }" id="modalLabel">{{ passwordResetText?.title }}</h2>
      <button
        class="button modal__button--close"
        type="button"
        (click)="closeModal(true)"
        [attr.aria-label]="'general.label.close' | translate"
      >
        <i class="icon icon-ui-close--sm" [ngStyle]="color && { 'background-color': '#' + color.color }"></i>
      </button>
    </header>
    <div class="modal__content">
      <div [internalInnerHtml]="passwordResetText?.body" [userEventSource]="userEventSource"></div>
      <air-form
        #formComponent
        [controls]="form"
        [alternateReCaptchaActions]="alternateReCaptchaActions"
        [userEventSource]="userEventSource"
        (submitted)="submitValues($event)"
      ></air-form>
    </div>
    <div>
      <div class="modal__footer" [ngClass]="{ 'modal__footer--standalone': standalone }">
        @if (!standalone) {
          <button type="button" class="button button--secondary" (click)="back($event)">
            <i class="icon icon-ui-arrow--left" [ngStyle]="color && { 'background-color': '#' + color.color }"></i>
            <span [ngStyle]="color && { color: '#' + color.color }">{{ 'general.label.back' | translate }}</span>
          </button>
        }
        <button
          type="submit"
          class="button form__button button--cta"
          [class.button--disabled]="formDisabled"
          [ngStyle]="color && { 'background-color': '#' + color.color }"
          [airButtonLoading]="isSubmitting"
          [disabled]="formDisabled"
          (click)="submit($event)"
        >
          <span>{{ 'general.label.send' | translate }}</span>
        </button>
      </div>
    </div>
  }
</div>
